import React from "react";
import { Route, Routes } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import ValidateRouteDetails from "./routes/ValidateRouteDetails";
import "./App.scss";

function Page404() {
  return (
    <div
      className="row text-center align-items-center m-0 text-danger fw-bold"
      style={{
        height: "100vh",
      }}
    >
      <div>
        <h1 style={{ fontWeight: "bolder" }}>ERROR 404</h1>
        <p className="mb-0">Page Not Found</p>
        <p
          className="mb-0 text-center mx-auto"
          style={{
            maxWidth: "550px",
          }}
        >
          If domain name is not entered then please use valid url with company
          domain assigned to you.
        </p>
        {/* <p>Contact admin for support.</p> */}
      </div>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route index element={<Page404 />} />
      <Route path=":companyDomain" element={<ValidateRouteDetails />}>
        <Route path=":languageCode">
          <Route path="*" element={<AppRoutes />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
